const NotFound: React.FC<Record<string, never>> = () => <div>Not Found</div>

export default NotFound
